import React from "react";
import styled from "styled-components";

import Button from "../button/Button";
import { getActAs, exitActAs } from "../../utils/actAs";

/**
 * 代理操作 (act-as) 中に画面下部へ固定表示するバナー。
 *
 * 管理者/マネージャーがアカウント管理ページから「マイページ」「プロフィール」
 * を開いている間（sessionStorage に act-as 状態がある間）、
 * 「〇〇として操作中」と終了ボタンを常時表示する。
 *
 * act-as 状態はフルリロード遷移でのみ変化するため、マウント時に一度だけ
 * 読み取れば十分（リアクティブな購読は不要）。
 */

// モーダル (z-index: 1000+) より下、GlobalHeader (z-index: 6) や
// BottomAppBar より上に浮かせる。
const BannerContainer = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  background: #fff;
  border: 1px solid var(--soremo-border);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 8px 8px 8px 16px;
  max-width: min(480px, calc(100vw - 32px));
`;

const BannerInner = styled.div.attrs({
  className: "u-row u-gap16",
})``;

const BannerText = styled.span.attrs({
  className: "bodytext-13",
})`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ActAsBanner: React.FC = () => {
  const actAs = getActAs();

  if (!actAs) {
    return null;
  }

  const name = actAs.displayName || `ユーザーID ${actAs.userId}`;

  return (
    <BannerContainer role="status">
      <BannerInner>
        <BannerText>「{name}」として操作中</BannerText>
        <Button
          size="small"
          theme="secondary"
          variant="outlined"
          width="fit"
          onClick={exitActAs}
        >
          終了
        </Button>
      </BannerInner>
    </BannerContainer>
  );
};

export default ActAsBanner;
